export const firstOrDefaultAsync = async (source, predicate) => {
    for (const value of source) {
        if (await predicate(value) === true) {
            return value;
        }
    }
    return null;
};
